export default {
	title: 'Cashier',
	subTitle: 'Create or edit Cashiers',
	content: [
		'Create a new cashier, if you don\'t create a PIN we\'ll randomly generate one for them.',
		'Update a previous cashiers PIN.'
	]
}



/** WEBPACK FOOTER **
 ** ./src/helpers/CashierInfo.js
 **/